module.exports = __webpack_public_path__ + "assets/images/be711d8d363608cca0c0c87e96a22d4d.avif";